// extracted by mini-css-extract-plugin
module.exports = {"header":"History_header__2b2G8","log":"History_log__2ULF4","name":"History_name__3WpWO","date":"History_date__1qVUZ"};